import type { DocumentInput, Recipient } from "@/lib/types";
import { SavedInput } from "./Fields";

const FIELDS: { key: keyof Recipient; label: string; className?: string; autoComplete?: string }[] = [
  { key: "name", label: "Name", className: "sm:col-span-2", autoComplete: "organization" },
  { key: "street", label: "Straße", className: "sm:col-span-2", autoComplete: "street-address" },
  { key: "zip", label: "PLZ", autoComplete: "postal-code" },
  { key: "city", label: "Ort", autoComplete: "address-level2" },
  { key: "country", label: "Land", autoComplete: "country-name" },
  { key: "vatId", label: "UID-Nummer" },
];

/** The recipient as printed on this document; changes stay on the document, the customer is not touched. */
export function RecipientFields({ recipient, save }: { recipient: Recipient; save: (input: DocumentInput) => Promise<unknown> }) {
  return (
    <div className="grid grid-cols-1 gap-3 rounded-lg bg-muted/50 p-3 sm:grid-cols-2">
      {FIELDS.map((f) => (
        <SavedInput
          key={f.key}
          label={f.label}
          className={f.className}
          autoComplete={f.autoComplete}
          value={recipient[f.key] ?? ""}
          save={(v) => save({ recipient: { [f.key]: f.key === "vatId" ? v.trim() || null : v } })}
        />
      ))}
    </div>
  );
}
